(() => {
  if (window.__productPageWishlistInitialized) return;
  window.__productPageWishlistInitialized = true;

  const STORAGE_KEY = 'abstractstate:wishlist:v1';
  const config = document.querySelector('[data-product-page-wishlist-config]');
  if (!config) return;

  const HEART_ICON = `
    <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path d="M16 28.4 13.9 26.5C6.4 19.7 1.5 15.3 1.5 9.9 1.5 5.5 4.9 2 9.3 2c2.5 0 4.9 1.2 6.7 3 1.8-1.8 4.2-3 6.7-3 4.4 0 7.8 3.5 7.8 7.9 0 5.4-4.9 9.8-12.4 16.6L16 28.4Z"></path>
    </svg>
  `;

  const normalizeUrl = (url) => {
    try {
      const parsed = new URL(url || '/', window.location.origin);
      return parsed.pathname.replace(/\/+$/, '') || '/';
    } catch (error) {
      return String(url || '').split('?')[0].replace(/\/+$/, '');
    }
  };

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const productData = () => {
    const activeImage = document.querySelector(
      'media-gallery .product__media-item.is-active img, media-gallery .product__media-item img'
    );

    return {
      url: normalizeUrl(config.dataset.url || window.location.pathname),
      title: (config.dataset.title || document.querySelector('.product__title h1')?.textContent || '').trim(),
      image: config.dataset.image || activeImage?.currentSrc || activeImage?.src || '',
      price: (config.dataset.price || '').trim(),
    };
  };

  const updateButton = (button, items = readWishlist()) => {
    if (!button) return;
    const active = items.some(
      (item) => normalizeUrl(item.url) === normalizeUrl(button.dataset.productUrl)
    );
    const title = button.dataset.productTitle || 'product';

    button.classList.toggle('is-favorite', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      active ? `Remove ${title} from favorites` : `Add ${title} to favorites`
    );
  };

  const syncVisibleUi = () => {
    const items = readWishlist();

    document.querySelectorAll('[data-card-wishlist]').forEach((button) => {
      updateButton(button, items);
    });

    const count = document.querySelector('.header-wishlist-count');
    if (count) {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    }

    const headerButton = document.querySelector('[data-header-wishlist]');
    if (headerButton) {
      headerButton.setAttribute('aria-label', `Favorites (${items.length})`);
    }
  };

  const notifyWishlistSystem = (items) => {
    try {
      window.dispatchEvent(
        new StorageEvent('storage', {
          key: STORAGE_KEY,
          newValue: JSON.stringify(items),
          url: window.location.href,
        })
      );
    } catch (error) {
      try {
        const event = new Event('storage');
        Object.defineProperty(event, 'key', { value: STORAGE_KEY });
        window.dispatchEvent(event);
      } catch (fallbackError) {}
    }
  };

  const writeWishlist = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {}
    syncVisibleUi();
    notifyWishlistSystem(items);
  };

  const publishWishlistEvent = (eventName, data, count) => {
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;

    const handleMatch = normalizeUrl(data.url).match(/\/products\/([^/?#]+)/);
    const payload = {
      product_handle: handleMatch ? decodeURIComponent(handleMatch[1]) : '',
      product_title: data.title || '',
      product_url: data.url || '',
      source: 'product_page',
      wishlist_count: count,
    };

    try {
      window.Shopify.analytics.publish(eventName, payload);
    } catch (error) {}
  };

  const toggleCurrentProduct = () => {
    const data = productData();
    if (!data.url) return;

    const items = readWishlist();
    const key = normalizeUrl(data.url);
    const index = items.findIndex((item) => normalizeUrl(item.url) === key);

    if (index >= 0) {
      items.splice(index, 1);
      writeWishlist(items);
      publishWishlistEvent('wishlist_remove', data, items.length);
    } else {
      items.unshift(data);
      writeWishlist(items);
      publishWishlistEvent('wishlist_add', data, items.length);
    }
  };

  const activeMediaItem = () => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return null;

    return (
      gallery.querySelector('.product__media-list .product__media-item.is-active') ||
      gallery.querySelector('.product__media-list .product__media-item')
    );
  };

  const mountButton = () => {
    const mediaItem = activeMediaItem();
    if (!mediaItem) return;
    const anchor = mediaItem.querySelector('.product-media-container');
    if (!anchor) return;

    document.querySelectorAll('.product-page-wishlist-anchor').forEach((node) => {
      if (node !== anchor) node.classList.remove('product-page-wishlist-anchor');
    });
    anchor.classList.add('product-page-wishlist-anchor');

    let button = document.querySelector('[data-product-page-wishlist]');
    const data = productData();

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'card-wishlist product-page-wishlist';
      button.dataset.cardWishlist = '';
      button.dataset.productPageWishlist = '';
      button.innerHTML = HEART_ICON;

      button.addEventListener('pointerdown', (event) => event.stopPropagation());
      button.addEventListener('pointerup', (event) => event.stopPropagation());
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleCurrentProduct();
      });
    }

    button.dataset.productUrl = data.url;
    button.dataset.productTitle = data.title;

    if (button.parentElement !== anchor) {
      anchor.appendChild(button);
    }

    updateButton(button);
  };

  const start = () => {
    mountButton();
    syncVisibleUi();

    const gallery = document.querySelector('media-gallery');
    if (gallery) {
      const observer = new MutationObserver(() => mountButton());
      observer.observe(gallery, { childList: true, subtree: true });
    }

    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('[data-product-page-wishlist]')) return;
        if (event.target.closest('.thumbnail, [data-media-id]')) {
          window.setTimeout(mountButton, 0);
        }
      },
      true
    );

    document.addEventListener('change', () => window.setTimeout(mountButton, 40), true);

    window.addEventListener('storage', (event) => {
      if (!event.key || event.key === STORAGE_KEY) syncVisibleUi();
    });

    document.addEventListener('shopify:section:load', mountButton);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
